// Phase 3.2b — Cycle Count detail sidebar (category list + product panel).
//
// UI-only migration: antd Row/Col/Input/Empty + MUI Skeleton + antd
// SearchOutlined → Tailwind layout + shadcn Input/EmptyState/Skeleton + Lucide
// Search icon. Every hook, effect, payload and dispatch is the legacy one; the
// category-list infinite scroll, search-on-type and status update flows are
// unchanged. Renders the (also-migrated) StatusCycleCount on the right.
import { useEffect, useState } from "react"
import { Search } from "lucide-react"
import StatusCycleCount from "./statusCycleCount"
import { useDispatch, useSelector } from "react-redux";
import { isArrayNotEmpty } from "../../Utils/helpers"
import { updateCycleCountAction } from "../../Store/actions/apparelAction"
import { useLocation } from "react-router-dom"
import { Input } from "ui/input"
import { Skeleton } from "ui/skeleton"
import { EmptyState } from "../../shared/empty-state"
import { cn } from "lib/utils"

const CycleCountSidebar = (props: any) => {
    const dispatch = useDispatch();
    const { searchTextApi,
        foot,
        single,
        categoryList,
        setCategoryList,
        setSearchText,
        setSearchTextOnLoad,
        searchTextOnLoad,
        getCategory,
        getMultipleCategoryListOnLoad,
        getProductListCategoryListOnLoad,
        productTextOnLoad,
        setProductTextOnLoad,
        statusRefIdOnClick,
        setCountIndex,
        countIndex,
        pendingButton,
        setProductCategoryMappingId,
        productCategroryMappingId
    } = props;

    const ApparelReducerState = useSelector((state: any) => state.ApparelReducerState);
    const { getProductListCategoryData, getUpdateCycleCountList } = ApparelReducerState;
    const getProduct = getProductListCategoryData?.getProductListByCategorySubCategory;
    const [countValue, setCountValue] = useState(0)
    const [mapping, setMapping] = useState<any>(null)
    const [manualMissing, setManualMissing] = useState<boolean>(false);
    const [movePending, setMovePending] = useState(false)
    const [isAvailable, setIsAvailable] = useState<any>(null);
    const locationProps = useLocation().state;
    const [spinOpen, setSpinOpen] = useState(false)
    const [InfiniteScroll, setInfiniteScroll] = useState(20)


    // Function to update the window height state
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const updateWindowHeight = () => {
        setWindowHeight(window.innerHeight);
    };
    useEffect(() => {
        window.addEventListener('resize', updateWindowHeight);
        return () => {
            window.removeEventListener('resize', updateWindowHeight);
        };
    }, [])

    useEffect(() => {
        // setProductCategoryMappingId(0);
        if (searchTextOnLoad === true && getMultipleCategoryListOnLoad === false) {
            setCountValue(getCategory?.[0]?.systemCount)
            setSearchTextOnLoad(false);
            setProductTextOnLoad(true);
            setProductCategoryMappingId(getCategory?.[0]?.categoryAndSubcategoryMappingId)
        }
    }, [searchTextOnLoad, getMultipleCategoryListOnLoad])

    useEffect(() => {
        if (productTextOnLoad === true && getProductListCategoryListOnLoad === false) {
            setInfiniteScroll(20)
            setProductTextOnLoad(false)
            setManualMissing(true)
        }
    }, [productTextOnLoad, getProductListCategoryListOnLoad])

    useEffect(() => {
        if (categoryList != undefined) {
            searchTextApi()
            setSearchText(false)
        }
    }, [categoryList])

    const searchBar = (e: any) => {
        setCategoryList({ ...categoryList, searchText: e?.target?.value })
        setSearchText(true)
    }

    useEffect(() => {
        if (manualMissing === true && getProductListCategoryListOnLoad === false) {
            if (isArrayNotEmpty(getProduct)) {
                setManualMissing(getProduct[0]?.availableCount)
            }
            setManualMissing(false)
        }
    }, [manualMissing, getProductListCategoryListOnLoad]);

    const systemCount = (idx: any, item: any) => {
        getCategory?.map((data: any, index: any) => {
            if (idx === index) {
                setMapping(data?.categoryAndSubcategoryMappingId)
                setCountValue(data?.systemCount)
                setCountIndex(idx)
                setIsAvailable(data?.isAvailabe)
                setProductCategoryMappingId(data?.categoryAndSubcategoryMappingId)
            }
        });
    };

    useEffect(() => {
        if (movePending && !getUpdateCycleCountList) {
            searchTextApi()
            setMovePending(false)
            setCountIndex(0);
            setProductCategoryMappingId(0);
        }
    }, [movePending, getUpdateCycleCountList])

    const updateCycleCountJobDetailStatusApi = (status: any) => {
        let payload = {
            cycleCountJobId: locationProps?.data?.cycleCountJobId,
            categoryAndSubCategoryMappingId: productCategroryMappingId,
            statusRefId: status
        }
        dispatch(updateCycleCountAction(payload));
        setMovePending(true)
    }

    const handleScroll = (e: any) => {
        let bottom;
        if (Math.ceil(e?.target?.scrollHeight) - Math.ceil(e?.target?.scrollTop) === Math.ceil(e?.target?.clientHeight)) {
            bottom = Math.ceil(e?.target?.scrollHeight) - Math.ceil(e?.target?.scrollTop) === Math.ceil(e?.target?.clientHeight)
        }
        else {
            bottom = Math.floor(e?.target?.scrollHeight) - Math.floor(e?.target?.scrollTop) === Math.floor(e?.target?.clientHeight)
        }
        setSpinOpen(false)
        if (bottom) {
            let scroll = isArrayNotEmpty(getCategory) && (getCategory.length > InfiniteScroll) ? 20 : 0
            setInfiniteScroll(scroll + InfiniteScroll)
            if (isArrayNotEmpty(getCategory) && (getCategory.length > InfiniteScroll)) {
                setSpinOpen(true)
            }
        }
    }

    let skeletonList: any = [1, 2, 3, 4, 5, 6];
    const sideBar = () => {
        let height = locationProps?.data?.statusRefId == 3 ? windowHeight - 155 : windowHeight - 230;
        let heightSideBarRows = locationProps?.data?.statusRefId == 3 ? windowHeight - 210 : windowHeight - 285;
        return (
            <div className="mz border-t">
                <div className="flex">
                    <div className="w-full max-w-[280px] shrink-0 border-r p-3" style={{ height: height }}>
                        <div className="relative">
                            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                            <Input className="pl-9" placeholder="Search By Category Name" onChange={(e: any) => searchBar(e)} />
                        </div>

                        <div className="mt-3 space-y-1.5 overflow-y-auto pr-1"
                            style={{ height: heightSideBarRows }}
                            onScroll={(e) => (handleScroll(e))}
                        >
                            {(getMultipleCategoryListOnLoad) ?
                                skeletonList.map((item: any, i: any) => (
                                    <Skeleton key={`sk-${i}`} className="h-[55px] w-full rounded-md" />
                                ))
                                :
                                (isArrayNotEmpty(getCategory) ? (getCategory.slice(0, InfiniteScroll) || []).map((data: any, index: any) => {
                                    return (
                                        <div
                                            key={index}
                                            className={cn(
                                                "cursor-pointer rounded-md border px-3 py-2.5 text-sm transition-colors hover:bg-muted",
                                                countIndex == index ? "border-primary bg-primary/10 font-medium" : "border-border"
                                            )}
                                            onClick={() => { systemCount(index, data) }}
                                        >
                                            <div className="truncate">{data?.categoryName} - {data?.subCategoryName}</div>
                                        </div>
                                    )
                                })
                                    :
                                    <EmptyState />
                                )
                            }
                        </div>
                    </div>
                    <div className="min-w-0 flex-1">
                        <StatusCycleCount
                            single={single}
                            foot={foot}
                            getProduct={getProduct}
                            productCategroryMappingId={productCategroryMappingId}
                            mapping={mapping}
                            statusRefIdOnClick={statusRefIdOnClick}
                            isAvailable={isAvailable}
                            countValue={countValue}
                            callBack={updateCycleCountJobDetailStatusApi}
                            pendingButton={pendingButton} />
                    </div>
                </div>
            </div>

        )
    }
    return (
        <div>{sideBar()}</div>
    )
}

export default CycleCountSidebar
